(function() {
  var moneyFormat = window.themeVariables?.settings?.moneyFormat || window.Shopify?.money_format || '${{amount}}';
  var productRoot = document.querySelector('.shopify-section--main-product');

  /* Removed: duplicate `window.dataLayer = window.dataLayer || []` - migrated to GTM (single init in layout/theme.liquid) */

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return '£' + (Number(cents || 0) / 100).toFixed(2);
  }

  /* Push chat widget above/below sticky bar dynamically.
     Shopify Inbox renders as <shopify-chat> custom element — its inner
     iframe is inside shadow DOM so we target the host element. */
  function adjustChatForSticky(stickyVisible) {
    var selectors = [
      'shopify-chat', '#ShopifyChat', '#shopify-chat',
      '#tidio-chat', '#tidio-chat-code', '#tidio-chat-iframe',
      'iframe[title="Tidio Chat"]', '[id^="tidio"]',
      '.intercom-lightweight-app',
      '[id*="chat-widget"]', '[class*="chat-widget"]',
      '[class*="chat-bubble"]', '[class*="chat-launcher"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        els[j].style.setProperty('bottom', stickyVisible ? '180px' : '20px', 'important');
        els[j].style.setProperty('right', stickyVisible ? '12px' : '16px', 'important');
        els[j].style.setProperty('z-index', '2147483646', 'important');
      }
    }
  }

  /* Stock Prestige handles ATC button text via product:rerender.
     updateMainAtc is a no-op stub kept for the variant:change listener below. */
  function updateMainAtc(variant) {}

  function updateStickyAtc(variant) {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky || !variant) return;

    var variantLabel = sticky.querySelector('[data-sticky-variant]');
    var buttonLabel = sticky.querySelector('[data-sticky-button-label]');
    var button = sticky.querySelector('[data-sticky-add]');

    if (variantLabel) variantLabel.textContent = variant.title;

    if (button) {
      /* Use aria-disabled for div-button (not .disabled property) */
      if (variant.available) {
        button.removeAttribute('aria-disabled');
      } else {
        button.setAttribute('aria-disabled', 'true');
      }
    }

    if (buttonLabel) {
      if (!variant.available) {
        buttonLabel.textContent = 'Sold Out';
      } else {
        /* Check fitting state — show "Schedule" or "Add to Cart" */
        var fitting = document.body.getAttribute('data-fitting');
        if (!fitting) {
          var bb = document.querySelector('buy-buttons');
          fitting = bb ? bb.getAttribute('data-fitting') : '';
        }
        buttonLabel.textContent = (fitting === 'included')
          ? 'Schedule an appointment'
          : 'Add to Cart \u00B7 ' + formatMoney(variant.price);
      }
    }
  }

  function initDeliveryPromise() {
    var el = document.querySelector('[data-delivery-date]');
    if (!el) return;

    var today = new Date();
    var businessDays = 5;
    var date = new Date(today);

    while (businessDays > 0) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) businessDays--;
    }

    el.textContent = date.toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'short'
    });
  }

  function initStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var mainButton = document.querySelector('.ks-atc-btn')
      || document.querySelector('.product-atc-btn')
      || document.querySelector('[data-ks-atc-trigger]');
    if (!sticky || !mainButton) return;

    var observer = new IntersectionObserver(function(entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      /* Dynamically push chat widget above sticky bar */
      adjustChatForSticky(show);
    }, { threshold: 0 });

    observer.observe(mainButton);

    sticky.querySelector('[data-sticky-add]')?.addEventListener('click', function(e) {
      /* Guard: div-button uses aria-disabled, not .disabled */
      if (e.currentTarget.getAttribute('aria-disabled') === 'true') return;
      window.dataLayer.push({
        event: 'sticky_atc_click',
        page_type: 'product'
      });
      mainButton.click();
    });
  }

  function initTracking() {
    // Trustpilot: new card (.kits-tp-badge) or legacy trustpilot-product-badge (.kits-tp-badge2)
    var tp = document.querySelector('.kits-tp-badge, .kits-tp-badge2');
    if (tp) {
      tp.addEventListener('click', function() {
        window.dataLayer.push({
          event: 'trust_signal_click',
          trust_source: 'trustpilot_product_badge',
          page_type: 'product'
        });
      });
    }

    // ATC source — distinguish sticky bar vs main button
    var stickyBtn = document.querySelector('[data-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        window.dataLayer.push({
          event: 'atc_source',
          button_location: 'sticky_bar'
        });
      });
    }

    var mainBtn = document.querySelector('[data-ks-atc-trigger]');
    if (mainBtn) {
      mainBtn.addEventListener('click', function() {
        window.dataLayer.push({
          event: 'atc_source',
          button_location: 'main_button'
        });
      });
    }

    var pills = document.querySelectorAll('.product-pill');
    if (pills.length) {
      window.dataLayer.push({
        event: 'urgency_pill_impression',
        pill_types: Array.from(pills).map(function(pill) {
          return pill.textContent.trim();
        }).join(',')
      });
    }

    var trustStrip = document.querySelector('.product-trust-strip, .kits-trust-strip');
    if (trustStrip) {
      window.dataLayer.push({
        event: 'trust_strip_visible',
        page_type: 'product'
      });
    }
  }

  function initTrustpilotCard() {
    var card = document.querySelector('[data-trustpilot-card]');
    if (!card) return;

    var reviewTarget = card.querySelector('[data-trustpilot-review]');
    var reviewItems = Array.from(card.querySelectorAll('[data-trustpilot-review-item]'))
      .map(function(item) {
        return item.textContent.trim();
      })
      .filter(Boolean);

    if (!reviewTarget || reviewItems.length < 2) return;

    var ROTATE_INTERVAL_MS = 4200;
    var COPY_SWAP_ANIMATION = 'kitsTrustpilotCopySwap';
    var currentIndex = Math.floor(Math.random() * reviewItems.length);
    reviewTarget.textContent = reviewItems[currentIndex];

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    window.setInterval(function rotateTrustpilotReview() {
      currentIndex = (currentIndex + 1) % reviewItems.length;
      card.classList.remove('is-animating');
      window.requestAnimationFrame(function applyTrustpilotReviewText() {
        reviewTarget.textContent = reviewItems[currentIndex];
        card.classList.add('is-animating');
      });
    }, ROTATE_INTERVAL_MS);

    card.addEventListener('animationend', function onTrustpilotCardAnimationEnd(event) {
      if (event.animationName === COPY_SWAP_ANIMATION) {
        card.classList.remove('is-animating');
      }
    });
  }

  // Delivery promise impression — fires once when block scrolls into view
  function initDeliveryImpression() {
    var dp = document.querySelector('.product-delivery-promise');
    if (!dp || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function(entries) {
      if (!entries[0].isIntersecting) return;
      var dateEl = dp.querySelector('[data-delivery-date]');
      window.dataLayer.push({
        event: 'delivery_promise_seen',
        delivery_date: dateEl ? dateEl.textContent.trim() : ''
      });
      obs.disconnect();
    }, { threshold: 0.5 });

    obs.observe(dp);
  }

  document.addEventListener('variant:change', function(event) {
    var variant = event.detail?.variant;
    if (!variant) return;
    updateMainAtc(variant);
    updateStickyAtc(variant);
    updateSaveBadge(variant);
    updateNotifyMe(variant);
  });

  function updateSaveBadge(variant) {
    var badge = document.querySelector('[data-save-badge]');
    if (!badge) return;

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    var pill = badge.querySelector('.ks-save-pill');
    if (pill) {
      if (onSale) {
        var saveAmount = variant.compare_at_price - variant.price;
        var savePct = Math.round((saveAmount / variant.compare_at_price) * 100);
        pill.textContent = 'Save ' + savePct + '%';
        pill.style.display = '';
      } else {
        pill.style.display = 'none';
      }
    }

    var showPayments = variant.price >= 3000;
    var badgesContainer = badge.querySelector('[data-payment-badges]');

    if (badgesContainer) {
      if (showPayments) {
        updatePayBadge(badgesContainer, '[data-klarna-text]',   variant.price / 3, 3);
        updatePayBadge(badgesContainer, '[data-clearpay-text]', variant.price / 4, 4);
        updatePayBadge(badgesContainer, '[data-pay4-text]', Math.floor(variant.price / 4), 4);
        badgesContainer.style.display = '';
      } else {
        badgesContainer.style.display = 'none';
      }
    }

    badge.hidden = !onSale && !showPayments;
  }

  function updatePayBadge(container, selector, amount, count) {
    var el = container.querySelector(selector);
    if (!el) return;
    var amountEl = el.querySelector('[data-pay-amount]');
    if (amountEl) amountEl.textContent = formatMoney(amount);
  }

  /* ── Notify Me: toggle form visibility + update hidden body field ─────
     Shows when variant.available === false (sold out).
     Also shows when variant is null/undefined (unavailable — no variant match).
     Hidden for available variants (including pre-order which has available=true).

     IMPORTANT: Uses event delegation on productRoot (stable element) because
     Prestige's rerender (theme.js:3238) replaces <buy-buttons> on every
     variant change, destroying any directly-bound event listeners. */

  function updateNotifyMe(variant) {
    var notifyEl = productRoot?.querySelector('[data-notify-me]');
    if (!notifyEl) return;

    /* Show if variant is sold out OR variant is null (unavailable) */
    var shouldShow = !variant || !variant.available;
    notifyEl.hidden = !shouldShow;

    /* Update the hidden body field with current variant info */
    if (shouldShow && variant) {
      var bodyInput = notifyEl.querySelector('[data-notify-body]');
      if (bodyInput) {
        bodyInput.value = 'Notify me when ' + (variant.name || variant.title || 'this product') +
          ' (SKU: ' + (variant.sku || 'N/A') + ') is back in stock. ' +
          'Variant ID: ' + variant.id;
      }
    }

    /* Reset success state when switching variants */
    var successEl = notifyEl.querySelector('[data-notify-success]');
    if (successEl) successEl.hidden = true;
    var formEl = notifyEl.querySelector('form');
    if (formEl) formEl.style.display = '';
  }

  /* ── Notify Me: AJAX submit — delegated on productRoot ─────────────
     Delegated handler survives <buy-buttons> rerender. Catches submit
     on any form inside [data-notify-me], posts via AJAX, shows success. */
  function initNotifyMeForm() {
    if (!productRoot) return;

    productRoot.addEventListener('submit', function(e) {
      /* Only intercept the notify-me form, not the product/cart form */
      var notifyWrapper = e.target.closest('[data-notify-me]');
      if (!notifyWrapper) return;

      e.preventDefault();

      var formEl = e.target;
      var btn = formEl.querySelector('.ks-notify-me__btn');
      var emailInput = formEl.querySelector('input[name="contact[email]"]');
      if (!emailInput || !emailInput.value) return;

      /* Disable while submitting */
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      /* Post to Shopify's contact endpoint */
      var formData = new FormData(formEl);
      fetch(formEl.action || '/contact', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function() {
        /* Show success message, hide the form inputs */
        var successEl = notifyWrapper.querySelector('[data-notify-success]');
        if (successEl) successEl.hidden = false;
        formEl.style.display = 'none';

        /* GA4 event */
        window.dataLayer.push({
          event: 'notify_me_submit',
          product_title: document.querySelector('.product-title')?.textContent?.trim() || '',
          email_captured: true
        });
      }).catch(function() {
        if (btn) { btn.disabled = false; btn.textContent = 'Notify Me'; }
      });
    });
  }

  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('.product-gallery__thumbnail');
    if (!thumb) return;

    var index = Array.prototype.indexOf.call(thumb.parentElement.children, thumb);
    var carousel = document.querySelector('.product-gallery__carousel');
    var mediaItems = carousel?.querySelectorAll('.product-gallery__media:not([hidden])');
    var target = mediaItems?.[index];
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  });

  function initThumbObserver() {
    var carousel = document.querySelector('.product-gallery__carousel');
    var thumbs = document.querySelectorAll('.product-gallery__thumbnail');
    var items = carousel?.querySelectorAll('.product-gallery__media:not([hidden])');
    if (!carousel || !thumbs.length || !items?.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var index = Array.prototype.indexOf.call(items, entry.target);
        thumbs.forEach(function(thumb, thumbIndex) {
          thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
        });
      });
    }, {
      root: carousel,
      threshold: 0.6
    });

    items.forEach(function(item) {
      observer.observe(item);
    });
  }

  /**
   * Appointo → Cart Drawer Bridge
   *
   * Problem: Appointo calls /cart/add.js then does window.location.href = "/cart".
   * Prestige uses a cart drawer that opens via "cart:change" CustomEvent.
   *
   * Solution:
   * 1. Intercept fetch to /cart/add.js — on success, open Prestige drawer
   * 2. Block Appointo's redirect by overriding Location.prototype.href setter
   */
  function initAppointoCartBridge() {
    if (window.themeVariables?.settings?.cartType !== 'drawer') return;

    var originalFetch = window.fetch;
    var blockRedirect = false;

    // Override Location.prototype.href setter to block /cart redirect
    var hrefDesc = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
    if (hrefDesc && hrefDesc.set) {
      var origHrefSet = hrefDesc.set;
      Object.defineProperty(Location.prototype, 'href', {
        get: hrefDesc.get,
        set: function(val) {
          if (blockRedirect && (val === '/cart' || val === '/checkout' || String(val).endsWith('/cart'))) {
            // Swallow redirect — cart drawer is opening instead
            blockRedirect = false;
            return;
          }
          return origHrefSet.call(this, val);
        },
        configurable: true,
        enumerable: true
      });
    }

    window.fetch = function(url, options) {
      var urlStr = typeof url === 'string' ? url : (url?.url || '');
      var isCartAdd = urlStr.includes('/cart/add');

      return originalFetch.apply(this, arguments).then(function(response) {
        if (!isCartAdd || !response.ok) return response;

        var cloned = response.clone();
        cloned.json().then(function(addData) {
          // Check if this is an Appointo booking (has _start_time)
          var items = addData.items || [addData];
          var isAppointo = items.some(function(item) {
            return item.properties && item.properties._start_time;
          });
          if (!isAppointo) return;

          // Block Appointo's upcoming redirect
          blockRedirect = true;
          setTimeout(function() { blockRedirect = false; }, 5000);

          // Fetch fresh cart then open drawer
          originalFetch.call(window, Shopify.routes.root + 'cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var sections = [];
              document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
                bubbles: true, detail: { sections: sections }
              }));

              if (sections.length > 0) {
                originalFetch.call(window, Shopify.routes.root + '?sections=' + sections.join(','))
                  .then(function(r) { return r.json(); })
                  .then(function(sectionData) {
                    cart.sections = sectionData;
                    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                      bubbles: true,
                      detail: { baseEvent: 'variant:add', cart: cart, onSuccessDo: 'force_open_drawer' }
                    }));
                  });
              } else {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                var drawer = document.querySelector('cart-drawer');
                if (drawer && drawer.show) setTimeout(function() { drawer.show(); }, 200);
              }
            });

          // Close Appointo modal
          setTimeout(function() {
            var modal = document.getElementById('appointo-modal');
            if (modal) modal.style.display = 'none';
          }, 300);
        });

        return response;
      });
    };
  }

  /* ═══════════════════════════════════════════════════════════════════════
   * APPOINTO LIFECYCLE — Survives Prestige rerender without stale refs.
   * ═══════════════════════════════════════════════════════════════════════
   *
   * ROOT CAUSE (the "insertAdjacentHTML no parent" error):
   *   Appointo scans for ATC buttons using its j[] selector array
   *   (appointo.js:456). If it finds one INSIDE <buy-buttons>, it
   *   captures a closure reference (o/ke). Prestige then destroys
   *   <buy-buttons> on rerender (theme.js:3238). Appointo's async
   *   variant-change handler (appointo.js:2159) resumes after the
   *   DOM swap and calls Te() → insertBefore(ke) on a parentless
   *   node → NoModificationAllowedError.
   *
   * FIX:
   *   Stock Prestige button <button type="submit" class="button w-full">
   *   matches ZERO of Appointo's 33 j[] selectors. When no match exists,
   *   Appointo takes the else branch (line 1546) and appends everything
   *   to document.body — completely outside the rerender zone.
   *
   *   CRITICAL: buy-buttons.liquid must NOT have name="add" on the
   *   submit button. The old .zip-check version did → that was the bug.
   *
   * What this function does:
   *   1. Intercepts form submit when fitting = "included" → opens modal
   *   2. Syncs fitting state from Prestige's data-fitting attribute
   *   3. Swaps .ks-atc-btn label: "Book Fitting" / "Add to cart"
   *   4. Keeps button visible after Appointo's ue()/fe() timing
   *
   * DOM hierarchy:
   *   .shopify-section--main-product
   *     product-rerender
   *       product-form                         ← STABLE (submit listener)
   *         [data-block-type="buy-buttons"]    ← STABLE (observer anchor)
   *           buy-buttons                      ← VOLATILE (replaced on rerender)
   *
   *   document.body (Appointo-managed, outside rerender):
   *     #appointo-btn                          ← hidden by CSS
   *     #appointo-modal
   *       #appointo-variant-select             ← our modal trigger
   * ═══════════════════════════════════════════════════════════════════════ */

  /* ═══════════════════════════════════════════════════════════════════════
   * APPOINTO LIFECYCLE v3 — Zero cached references, fully delegated.
   * ═══════════════════════════════════════════════════════════════════════
   *
   * WHY v3:
   *   Prestige's onRerender_fn (theme.js:3235-3266) has TWO paths:
   *
   *   A) FULL REPLACE (productChange=true OR no allow-partial-rerender):
   *      this.replaceWith(matchingElement) — ENTIRE <product-rerender>
   *      is swapped, destroying <product-form>, <form>, everything.
   *      All cached refs (productForm, nativeForm) become orphans.
   *      All listeners attached to them are dead.
   *
   *   B) PARTIAL REPLACE (allow-partial-rerender + variant change):
   *      Iterates blockTypes array and replaces EACH block individually.
   *      "variant-picker" IS in the list (line 3244) — so the entire
   *      [data-block-type="variant-picker"] element is replaced.
   *      "buy-buttons" — only the inner <buy-buttons> is replaced.
   *
   *   Both events (product:rerender, variant:change) fire on the <form>
   *   element (theme.js:3227, 3370), with bubbles:true.
   *
   * STRATEGY:
   *   1. NEVER cache element refs. Always query fresh from productRoot.
   *   2. Submit interception via document-level capture (survives everything).
   *   3. Events on document (variant:change, product:rerender bubble there).
   *   4. MutationObserver on productRoot (stable .shopify-section element).
   *   5. Hard safety restores at 300ms, 1000ms, 2000ms.
   * ═══════════════════════════════════════════════════════════════════════ */

  function initAppointoLifecycle() {
    if (!productRoot.querySelector('product-form')) return;

    var fitting = 'excluded';
    var reconcileTimers = [];
    var isReconciling = false;  /* Re-entrancy guard — prevents observer→reconcile loop */
    var mutationDebounce = null;

    /* ─── FRESH DOM QUERIES ────────────────────────────────────────
       Every function queries live DOM. Never stores refs across ticks. */

    function getForm() {
      return productRoot.querySelector('product-form form[action*="/cart/add"]')
        || productRoot.querySelector('product-form form');
    }

    function getBuyButtons() {
      return productRoot.querySelector('buy-buttons');
    }

    function getAtcBtn() {
      /* .ks-atc-btn lives OUTSIDE <buy-buttons> (sibling, not child)
         to survive Appointo removal of buy-buttons. Query from productRoot. */
      return productRoot.querySelector('.ks-atc-btn');
    }

    function getPaymentButton() {
      var bb = getBuyButtons();
      return bb ? bb.querySelector('.shopify-payment-button') : null;
    }

    function getVariantPicker() {
      return productRoot.querySelector('variant-picker');
    }

    function getFittingFieldset() {
      var vp = getVariantPicker();
      if (!vp) return null;
      var fieldsets = vp.querySelectorAll('fieldset.variant-picker__option');
      for (var i = 0; i < fieldsets.length; i++) {
        var legend = fieldsets[i].querySelector('legend');
        var text = legend?.textContent?.trim().toLowerCase() || '';
        if (text === 'fitting:' || text === 'fitting') return fieldsets[i];
      }
      return null;
    }

    /* ─── 1. SUBMIT INTERCEPTION ───────────────────────────────────
       Document-level capture. Survives all rerenders because it's on
       document, not on any replaceable element.
       Scoped: only intercepts forms inside productRoot. */

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !productRoot.contains(form)) return;
      /* Only intercept the product cart-add form, not notify-me etc */
      if (form.closest('[data-notify-me]')) return;
      if (!form.closest('product-form')) return;

      syncFitting();
      if (fitting !== 'included') return;

      e.preventDefault();
      e.stopImmediatePropagation();
      openAppointoModal();
    }, true); /* capture phase — fires BEFORE Prestige's handler */

    /* ─── 2. EVENT LISTENERS (all on document, scoped) ─────────────
       Both product:rerender and variant:change fire on the <form>
       element and bubble to document. We catch them here. */

    document.addEventListener('variant:change', function(e) {
      if (!productRoot.contains(e.target) && e.target !== productRoot) return;
      reconcile();
    });

    document.addEventListener('product:rerender', function(e) {
      if (!productRoot.contains(e.target) && e.target !== productRoot) return;
      reconcile();
    });

    /* Change events from variant picker radios */
    document.addEventListener('change', function(e) {
      if (!e.target.closest || !productRoot.contains(e.target)) return;
      if (!e.target.closest('variant-picker')) return;
      reconcile();
    });

    /* ─── 3. MUTATION OBSERVER (on productRoot — never replaced) ───
       productRoot is .shopify-section--main-product, the outermost
       section wrapper. It is NEVER replaced by Prestige. Catches
       all DOM changes including full product-rerender swap. */

    new MutationObserver(function() {
      /* Skip if we're inside a runPass — our own DOM writes trigger this */
      if (isReconciling) return;
      /* Debounce rapid mutations (e.g. Prestige replacing multiple blocks) */
      clearTimeout(mutationDebounce);
      mutationDebounce = setTimeout(reconcile, 60);
    }).observe(productRoot, { childList: true, subtree: true });

    /* ─── FITTING STATE ────────────────────────────────────────────── */

    function syncFitting() {
      /* Priority 1: data-fitting attribute on body (set by theme.js) */
      var bodyFitting = document.body.getAttribute('data-fitting');
      if (bodyFitting === 'included' || bodyFitting === 'excluded') {
        fitting = bodyFitting;
        return;
      }

      /* Priority 2: data-fitting on <buy-buttons> */
      var bb = getBuyButtons();
      var bbFitting = bb ? bb.getAttribute('data-fitting') : '';
      if (bbFitting === 'included' || bbFitting === 'excluded') {
        fitting = bbFitting;
        return;
      }

      /* Priority 3: read directly from the variant picker radio */
      fitting = readFittingFromPicker();
    }

    function readFittingFromPicker() {
      var fs = getFittingFieldset();
      if (!fs) return 'excluded';

      var checked = fs.querySelector('input[data-option-position]:checked');
      if (!checked) return 'excluded';

      var lbl = fs.querySelector('label[for="' + checked.id + '"]');
      var text = lbl?.textContent?.trim().toLowerCase() || '';

      return (text === 'included' || text.includes('professional') || text.includes('we handle'))
        ? 'included'
        : 'excluded';
    }

    /* ─── VISIBILITY RESTORE ───────────────────────────────────────── */

    function restoreEl(el) {
      if (!el) return;
      if (el.hasAttribute('hidden')) el.removeAttribute('hidden');
      if (el.style.display === 'none') el.style.removeProperty('display');
      if (el.style.visibility === 'hidden') el.style.removeProperty('visibility');
      if (el.style.opacity === '0') el.style.removeProperty('opacity');
      if (el.getAttribute('aria-hidden') === 'true') el.removeAttribute('aria-hidden');
      /* Appointo ue() can inject inline left:-810px to move elements offscreen */
      if (el.style.left && el.style.left !== 'auto') el.style.removeProperty('left');
      if (el.style.position === 'absolute') el.style.removeProperty('position');
      /* Appointo may also inject inline background:transparent */
      if (el.style.background === 'transparent' || el.style.backgroundColor === 'transparent') {
        el.style.removeProperty('background');
        el.style.removeProperty('background-color');
      }
    }

    function ensureVisible() {
      /* Variant picker + all its fieldsets */
      var vpBlock = productRoot.querySelector('[data-block-type="variant_picker"]');
      var vp = getVariantPicker();
      restoreEl(vpBlock);
      restoreEl(vp);
      if (vp) {
        var fsets = vp.querySelectorAll('fieldset');
        for (var i = 0; i < fsets.length; i++) restoreEl(fsets[i]);
      }

      /* ATC button — lives OUTSIDE <buy-buttons> now, query all instances */
      var buttons = productRoot.querySelectorAll('.ks-atc-btn');
      for (var i = 0; i < buttons.length; i++) restoreEl(buttons[i]);

      /* Buy buttons decoy — restore in case Appointo hid it */
      var bb = getBuyButtons();
      restoreEl(bb);

      /* Payment button (still inside <buy-buttons>) */
      var pay = getPaymentButton();
      if (!pay) return;
      var btn = buttons[0]; /* main product form button */
      var isUnavailable = btn?.getAttribute('aria-disabled') === 'true';

      if (isUnavailable || fitting === 'included') {
        /* Sold out or booking mode: clear inline overrides, let CSS rules decide */
        pay.style.removeProperty('display');
        pay.style.removeProperty('visibility');
        pay.style.removeProperty('opacity');
      } else {
        /* Normal ATC mode: force visible, overriding any Appointo inline hide */
        restoreEl(pay);
        pay.style.setProperty('display', 'block', 'important');
        pay.style.removeProperty('visibility');
        pay.style.removeProperty('opacity');
      }
    }

    function syncButtonLabel() {
      /* Update ALL .ks-atc-btn elements (main product form + desktop sticky bar + mobile sticky bar).
         Mobile sticky bar has <span data-sticky-button-label> inside — update that child
         instead of replacing .textContent (which would destroy the span). */
      var label = (fitting === 'included')
        ? 'Schedule an appointment'
        : (window.themeVariables?.strings?.addToCart || 'Add to cart');
      var buttons = productRoot.querySelectorAll('.ks-atc-btn');
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].getAttribute('aria-disabled') === 'true') continue;
        var innerSpan = buttons[i].querySelector('[data-sticky-button-label]');
        if (innerSpan) {
          /* Mobile sticky bar: include price in label for fitting=excluded */
          if (fitting !== 'included') {
            var priceEl = productRoot.querySelector('sale-price .price');
            var price = priceEl ? priceEl.textContent.trim() : '';
            innerSpan.textContent = price ? label + ' \u00B7 ' + price : label;
          } else {
            innerSpan.textContent = label;
          }
        } else {
          buttons[i].textContent = label;
        }
      }
    }

    /* ─── RECONCILE ────────────────────────────────────────────────── */

    function ensureButtonStyles() {
      /* Last-resort JS fallback: if computed background is still transparent
         after CSS and restoreEl(), force inline styles directly. */
      var btns = document.querySelectorAll('.ks-atc-btn');
      for (var i = 0; i < btns.length; i++) {
        var cs = getComputedStyle(btns[i]);
        if (cs.backgroundColor === 'rgba(0, 0, 0, 0)' || cs.backgroundColor === 'transparent' ||
            cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') {
          btns[i].style.cssText += ';display:flex!important;background:linear-gradient(135deg,#1a1a1a 0%,#2d2d2d 100%)!important;background-color:#1a1a1a!important;color:#fff!important;visibility:visible!important;opacity:1!important;position:relative!important;left:auto!important;';
        }
      }
    }

    var reconcileGuardTimeout = null;

    function runPass() {
      isReconciling = true;
      syncFitting();
      ensureVisible();
      syncButtonLabel();
      ensureButtonStyles();
      /* Keep isReconciling true for 80ms after DOM writes so the
         MutationObserver callback (which checks this flag) ignores
         mutations caused by our own DOM changes. */
      clearTimeout(reconcileGuardTimeout);
      reconcileGuardTimeout = setTimeout(function() { isReconciling = false; }, 80);
    }

    function reconcile() {
      /* Clear any pending timers from previous reconcile */
      for (var i = 0; i < reconcileTimers.length; i++) {
        clearTimeout(reconcileTimers[i]);
      }
      reconcileTimers.length = 0;

      /* Immediate */
      runPass();

      /* rAF — after current paint */
      requestAnimationFrame(runPass);

      /* Hard safety restores at escalating intervals:
         300ms  — Prestige async DOM completion
         1000ms — Appointo ue() initial pass
         2000ms — Appointo fe() delayed restore (1500ms) + buffer */
      reconcileTimers.push(setTimeout(runPass, 300));
      reconcileTimers.push(setTimeout(runPass, 1000));
      reconcileTimers.push(setTimeout(runPass, 2000));
    }

    /* ─── APPOINTO MODAL ───────────────────────────────────────────── */

    function openAppointoModal() {
      /* Primary path: click Appointo's own button. This triggers its full
         internal flow (r.onclick at appointo.js:1566) which sets up state,
         opens the modal, and initializes the calendar correctly. */
      var appointoBtn = document.getElementById('appointo-btn');
      if (appointoBtn) {
        appointoBtn.click();
        return;
      }

      /* Fallback: Appointo still loading — retry after its typical init time */
      setTimeout(function() {
        var btn = document.getElementById('appointo-btn');
        if (btn) {
          btn.click();
          return;
        }

        /* Last resort: direct DOM manipulation if #appointo-btn never appeared */
        var modal = document.getElementById('appointo-modal');
        var varSelect = document.getElementById('appointo-variant-select');
        if (modal && varSelect) showModal(modal, varSelect);
      }, 2500);
    }

    function showModal(modal, varSelect) {
      modal.style.display = 'block';

      var slotsEl = document.getElementById('calendar_slots');
      if (slotsEl) slotsEl.innerHTML = '';

      for (var i = 0; i < varSelect.options.length; i++) {
        if (!varSelect.options[i].disabled) {
          varSelect.value = varSelect.options[i].value;
          break;
        }
      }

      varSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* ─── INITIAL SYNC ─────────────────────────────────────────────── */
    reconcile();

    /* Expose for console debugging */
    window.syncButtonLabel = syncButtonLabel;
    window.openAppointoModal = openAppointoModal;
  }

  /* ═══════════════════════════════════════════════════════════════════════
   * DIV-BUTTON HANDLER — Delegated on document, survives all rerenders.
   * ═══════════════════════════════════════════════════════════════════════
   *
   * .ks-atc-btn lives OUTSIDE <buy-buttons> (sibling, not child) so it
   * survives both Appointo removal and Prestige rerender of <buy-buttons>.
   *
   * In the main product form, .ks-atc-btn is inside {%- form 'product' -%}
   * so btn.closest('form') finds the cart-add form.
   *
   * In the desktop sticky bar, there's no ancestor <form>. The button has
   * data-form-id="{{ product_form_id }}" so we fall back to getElementById.
   *
   * Click or Enter/Space on the div triggers form.requestSubmit(), which
   * dispatches a real 'submit' event. Prestige's <product-form> catches
   * that event → AJAX /cart/add.js.
   *
   * Delegated on document → no re-binding needed after rerender.
   * Checks aria-disabled → respects sold-out / unavailable state.
   * ═══════════════════════════════════════════════════════════════════════ */

  function triggerAtc(btn) {
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;

    /* .ks-atc-btn lives outside <buy-buttons>. In the main product form it's
       still inside {%- form 'product' -%}, so btn.closest('form') works.
       In the desktop sticky bar there's no ancestor <form> — fall back to
       data-form-id attribute which points to the main product form by ID. */
    var form = btn.closest('form');
    if (!form) {
      var formId = btn.getAttribute('data-form-id');
      if (formId) form = document.getElementById(formId);
    }
    if (!form) return;

    /* requestSubmit() fires the submit event (unlike form.submit()),
       so Prestige's product-form intercept works correctly. */
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      /* Safari <16 fallback: dispatch submit event manually */
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.ks-atc-btn');
    if (btn) triggerAtc(btn);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('.ks-atc-btn');
    if (!btn) return;
    e.preventDefault(); /* Prevent Space from scrolling */
    triggerAtc(btn);
  });

  /* ═══════════════════════════════════════════════════════════════════════ */

  if (productRoot) {
    initDeliveryPromise();
    initDeliveryImpression();
    initStickyAtc();
    initTracking();
    initTrustpilotCard();
    initThumbObserver();
    initAppointoLifecycle();
    initAppointoCartBridge();
    initNotifyMeForm();
    initNotifyMeOnLoad();
  }

  /* ── Notify Me: initial state on page load ─────────────────────────
     No variant:change fires on initial load, so check the ATC button
     state to determine if the current variant is sold out/unavailable.
     The Liquid hidden attribute uses selected_or_first_available_variant
     which is always available — so JS must correct it for sold-out URLs. */
  function initNotifyMeOnLoad() {
    var notifyEl = productRoot?.querySelector('[data-notify-me]');
    var atcBtn = productRoot?.querySelector('.ks-atc-btn');
    if (!notifyEl || !atcBtn) return;

    var isDisabled = atcBtn.getAttribute('aria-disabled') === 'true';
    notifyEl.hidden = !isDisabled;
  }
})();

/* Cart drawer timers moved to kits-cart-global.js (loads on ALL pages via theme.liquid) */

/* ═══════════════════════════════════════════════════════════════════════
   CHAT BUTTON POSITION MANAGER — JS Fallback
   ═══════════════════════════════════════════════════════════════════════
   Ensures chat widgets don't overlap sticky ATC bar or cart drawer.
   CSS :has() handles this in modern browsers; this IIFE covers:
     - Older browsers without :has()
     - Chat widgets injected after initial DOM paint (Tidio, Gorgias, etc.)
   ═══════════════════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  /* Only run on mobile viewports */
  if (window.innerWidth > 749) return;

  var CHAT_SELECTORS = [
    '#tidio-chat', '#tidio-chat-iframe', '.tidio-chat',
    '#chat-widget-container',
    '#gorgias-chat-container', '#gorgias-chat-messenger-container',
    '[id*="chat-widget"]', '[id*="chat-button"]',
    '#shopify-chat', '.shopify-chat', '#ShopifyChat', 'shopify-chat'
  ].join(',');

  var STICKY_BOTTOM = '100px';
  var DEFAULT_BOTTOM = '20px';

  function getChatEls() {
    return document.querySelectorAll(CHAT_SELECTORS);
  }

  function isStickyVisible() {
    var sticky = document.querySelector('[data-sticky-atc]');
    return sticky && sticky.getAttribute('aria-hidden') !== 'true';
  }

  function isCartDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && drawer.hasAttribute('open');
  }

  function updateChatPosition() {
    var chatEls = getChatEls();
    if (!chatEls.length) return;

    var drawerOpen = isCartDrawerOpen();
    var stickyUp = isStickyVisible();

    chatEls.forEach(function(el) {
      if (drawerOpen) {
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      } else {
        el.style.removeProperty('opacity');
        el.style.removeProperty('pointer-events');
        el.style.setProperty('bottom', stickyUp ? STICKY_BOTTOM : DEFAULT_BOTTOM, 'important');
      }
    });
  }

  /* ── Observe sticky bar aria-hidden changes ── */
  var sticky = document.querySelector('[data-sticky-atc]');
  if (sticky) {
    new MutationObserver(updateChatPosition)
      .observe(sticky, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  /* ── Observe cart drawer open/close ── */
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(updateChatPosition)
      .observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── Observe body for late-injected chat widgets ── */
  var chatObserverTimeout = null;
  new MutationObserver(function(mutations) {
    if (chatObserverTimeout) return;
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType === 1 && node.matches && node.matches(CHAT_SELECTORS)) {
          chatObserverTimeout = setTimeout(function() {
            chatObserverTimeout = null;
            updateChatPosition();
          }, 200);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true });

  /* Initial position + resize handler */
  updateChatPosition();
  window.addEventListener('resize', function() {
    if (window.innerWidth > 749) {
      /* Desktop: reset chat to defaults */
      getChatEls().forEach(function(el) {
        el.style.removeProperty('bottom');
        el.style.removeProperty('opacity');
        el.style.removeProperty('pointer-events');
      });
    } else {
      updateChatPosition();
    }
  });
})();


/* ═══════════════════════════════════════════════════════════════
   NEWSLETTER POPUP — Removed
   ═══════════════════════════════════════════════════════════════
   The snippet-based newsletter popup has been removed.
   Newsletter popup is now handled by sections/newsletter-popup.liquid
   ═══════════════════════════════════════════════════════════════ */


/* ═══════════════════════════════════════════════════════════════
   FLOATING PRODUCT BUBBLE — Related Product Notification
   ═══════════════════════════════════════════════════════════════
   Shows related products periodically on product pages.
   Fetches from Shopify /recommendations/products.json.
   Cycles through up to 5 related products, max 5 shows per session.
   ═══════════════════════════════════════════════════════════════ */

(function ksProductBubble() {
  'use strict';

  // Only run on product pages
  if (!/\/products\//.test(window.location.pathname)) return;

  console.log('[KS Bubble] IIFE executing on product page');

  const CONFIG = {
    showInterval:    12000,  // 12s between appearances
    displayDuration: 6000,   // visible for 6s
    initialDelay:    8000,   // first show after 8s (after newsletter popup fires)
    maxShows:        5       // per page load
  };

  let showCount      = 0;
  let bubbleEl       = null;
  let recommendations = [];
  let currentIndex   = 0;
  let hideTimeout    = null;
  let cycleInterval  = null;

  // ─── Resolve product ID ───

  function getProductId() {
    // Prestige theme: data-product-json script in main-product section
    const jsonScript = document.querySelector('[data-product-json], [type="application/json"][data-product]');
    if (jsonScript) {
      try {
        const data = JSON.parse(jsonScript.textContent);
        if (data.id) return data.id;
      } catch (e) { /* ignore */ }
    }

    // Fallback: meta tag
    const meta = document.querySelector('meta[property="og:id"], meta[name="product-id"]');
    if (meta) return meta.content;

    // Fallback: data attribute on product section
    const section = document.querySelector('[data-product-id]');
    if (section) return section.dataset.productId;

    // Fallback: Shopify global
    if (window.ShopifyAnalytics?.meta?.product?.id) {
      return window.ShopifyAnalytics.meta.product.id;
    }

    return null;
  }

  // ─── Fetch recommendations ───

  async function fetchRecommendations() {
    const productId = getProductId();
    if (!productId) {
      console.log('[KS Bubble] No product ID found');
      return [];
    }

    try {
      const resp = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=5&intent=related`
      );
      if (!resp.ok) throw new Error(resp.status);
      const data = await resp.json();
      console.log('[KS Bubble] Fetched', data.products?.length || 0, 'recommendations');
      return data.products || [];
    } catch (err) {
      console.log('[KS Bubble] Fetch error:', err);
      return [];
    }
  }

  // ─── Build bubble DOM (once) ───

  function createBubble() {
    const el = document.createElement('a');
    el.className = 'ks-product-bubble';
    el.id = 'ks-product-bubble';
    el.setAttribute('role', 'complementary');
    el.setAttribute('aria-label', 'Related product suggestion');

    el.innerHTML =
      '<button class="ks-product-bubble__close" aria-label="Close" type="button">\u00D7</button>' +
      '<div class="ks-product-bubble__image-wrap">' +
        '<img class="ks-product-bubble__image" src="" alt="" loading="lazy" width="56" height="56">' +
      '</div>' +
      '<div class="ks-product-bubble__content">' +
        '<span class="ks-product-bubble__badge">Selling Fast</span>' +
        '<span class="ks-product-bubble__title"></span>' +
        '<span class="ks-product-bubble__price"></span>' +
      '</div>' +
      '<span class="ks-product-bubble__arrow">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
          '<polyline points="9,18 15,12 9,6"/>' +
        '</svg>' +
      '</span>';

    document.body.appendChild(el);
    return el;
  }

  // ─── Update content for current product ───

  function updateContent(product) {
    if (!bubbleEl || !product) return;

    // Image — use Shopify CDN sizing
    const img = bubbleEl.querySelector('.ks-product-bubble__image');
    if (img) {
      const src = product.featured_image || (product.images && product.images[0]);
      img.src = src
        ? src.replace(/(\.[^.]+)$/, '_120x120_crop_center$1')
        : '';
      img.alt = product.title || '';
    }

    // Title
    const title = bubbleEl.querySelector('.ks-product-bubble__title');
    if (title) title.textContent = product.title || '';

    // Price (with compare-at if on sale)
    const priceEl = bubbleEl.querySelector('.ks-product-bubble__price');
    if (priceEl) {
      const price = (product.price / 100).toFixed(2);
      let html = '&pound;' + price;
      if (product.compare_at_price && product.compare_at_price > product.price) {
        const compare = (product.compare_at_price / 100).toFixed(2);
        html += ' <span class="ks-product-bubble__compare">&pound;' + compare + '</span>';
      }
      priceEl.innerHTML = html;
    }

    // Link
    bubbleEl.href = product.url || ('/products/' + product.handle);
  }

  // ─── Show / Hide ───

  function show() {
    if (showCount >= CONFIG.maxShows || recommendations.length === 0) {
      stopCycle();
      return;
    }

    // Don't show if newsletter popup or cart drawer is open
    if (document.body.classList.contains('ks-popup-open')) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.hasAttribute('open')) return;

    const product = recommendations[currentIndex];
    currentIndex = (currentIndex + 1) % recommendations.length;
    updateContent(product);

    bubbleEl.classList.remove('is-leaving');
    bubbleEl.classList.add('is-visible');
    showCount++;

    console.log('[KS Bubble] Show #' + showCount + ':', product.title);

    // Auto-hide
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(hide, CONFIG.displayDuration);
  }

  function hide() {
    if (!bubbleEl) return;
    clearTimeout(hideTimeout);
    bubbleEl.classList.add('is-leaving');
    setTimeout(() => {
      bubbleEl.classList.remove('is-visible', 'is-leaving');
    }, 500);
  }

  function dismiss() {
    hide();
    showCount = CONFIG.maxShows; // permanently stop
    stopCycle();
    console.log('[KS Bubble] Dismissed by user');
  }

  function stopCycle() {
    if (cycleInterval) { clearInterval(cycleInterval); cycleInterval = null; }
  }

  // ─── Init ───

  async function init() {
    recommendations = await fetchRecommendations();
    if (recommendations.length === 0) return;

    bubbleEl = createBubble();

    // Close button — stop propagation so <a> doesn't navigate
    const closeBtn = bubbleEl.querySelector('.ks-product-bubble__close');
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      dismiss();
    });

    // GA4 tracking on click-through
    bubbleEl.addEventListener('click', (e) => {
      if (e.target.closest('.ks-product-bubble__close')) return;
      if (typeof dataLayer !== 'undefined') {
        const product = recommendations[(currentIndex - 1 + recommendations.length) % recommendations.length];
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: 'select_item',
          ecommerce: {
            item_list_name: 'product_bubble',
            items: [{
              item_id: String(product.id),
              item_name: product.title,
              price: product.price / 100
            }]
          }
        });
      }
    });

    // First show
    setTimeout(show, CONFIG.initialDelay);

    // Repeat cycle
    cycleInterval = setInterval(() => {
      if (showCount < CONFIG.maxShows && !bubbleEl.classList.contains('is-visible')) {
        show();
      }
    }, CONFIG.showInterval);
  }

  // ─── Boot ───

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Judge.me PDP reviews: keep cards visible, add mobile Show More (no DOM reshuffle). */
(function () {
  var MOBILE_MAX = 749;

  function getReviewsHost(widget) {
    var host = widget.querySelector('.jdgm-rev-widg__reviews');
    if (host) return host;
    var firstReview = widget.querySelector('.jdgm-rev');
    if (!firstReview || !firstReview.parentElement) return null;
    return firstReview.parentElement;
  }

  function setReviewVisibility(host, expanded) {
    var reviews = host.querySelectorAll('.jdgm-rev');
    var isMobile = window.innerWidth <= MOBILE_MAX;

    reviews.forEach(function (review, index) {
      var hidden = isMobile && !expanded && index >= 3;
      review.classList.toggle('ks-jdgm-rev--hidden-mobile', hidden);

      var item = review.closest('li');
      if (item && host.contains(item)) {
        item.classList.toggle('ks-jdgm-rev--hidden-mobile', hidden);
      }
    });
  }

  function ensureShowMore(section, host) {
    var reviews = host.querySelectorAll('.jdgm-rev');
    var button = section.querySelector('[data-ks-jdgm-show-more]');

    if (window.innerWidth > MOBILE_MAX || reviews.length <= 3) {
      if (button) button.remove();
      setReviewVisibility(host, true);
      return;
    }

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'ks-jdgm-show-more is-visible';
      button.setAttribute('data-ks-jdgm-show-more', '');
      host.insertAdjacentElement('afterend', button);
    }

    var expanded = button.getAttribute('data-expanded') === '1';
    setReviewVisibility(host, expanded);
    button.textContent = expanded ? 'Show less' : 'Show all ' + reviews.length + ' reviews';

    button.onclick = function () {
      expanded = !expanded;
      button.setAttribute('data-expanded', expanded ? '1' : '0');
      setReviewVisibility(host, expanded);
      button.textContent = expanded ? 'Show less' : 'Show all ' + host.querySelectorAll('.jdgm-rev').length + ' reviews';
    };
  }

  function enhance(widget) {
    var section = widget.closest('.shopify-section--product-customer-reviews');
    if (!section) return;

    var host = getReviewsHost(widget);
    if (!host) return;

    host.style.visibility = 'visible';
    host.style.opacity = '1';

    host.querySelectorAll('.jdgm-rev').forEach(function (review) {
      review.style.visibility = 'visible';
      review.style.opacity = '1';
      review.style.display = 'flex';
    });

    ensureShowMore(section, host);
  }

  function boot() {
    var widget = document.querySelector('#judgeme_product_reviews');
    if (!widget) return;

    var observer = null;
    var refreshDebounce = null;

    function startObserving() {
      if (observer) observer.observe(widget, { childList: true, subtree: true });
    }

    function refresh() {
      if (observer) observer.disconnect();
      try {
        enhance(widget);
      } catch (e) {
        /* Judge.me DOM can change while rendering */
      }
      setTimeout(startObserving, 100);
    }

    refresh();

    observer = new MutationObserver(function() {
      if (refreshDebounce) return;
      refreshDebounce = setTimeout(function() {
        refreshDebounce = null;
        refresh();
      }, 300);
    });
    startObserving();

    setTimeout(refresh, 400);
    setTimeout(refresh, 2000);

    window.addEventListener('resize', function() {
      if (refreshDebounce) clearTimeout(refreshDebounce);
      refreshDebounce = setTimeout(function() {
        refreshDebounce = null;
        refresh();
      }, 150);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

